export default {
  destinationsByRegion: {
    url: `/destinations/national-by-region`,
    method: `GET`,
  },
  destinationsByZone: {
    url: `/destinations/interntional-by-zone`,
    method: `GET`,
  },
  destinationsByMacrozone: {
    url: `/destinations/international-by-mracrozone`,
    method: `GET`,
  },
  getLanguages: {
    url: `/foreing-languages`,
    method: `GET`,
  },
  // Categories
  nationalCategories: {
    url: `/categories/kind/1`,
    method: `GET`,
  },
  internationalCategories: {
    url: `/categories/kind/2`,
    method: `GET`,
  },
  getSubcategories: {
    url: `/categories/subcategories`,
    method: `GET`,
  },
  // Regions
  getRegions: {
    url: `/all-regions`,
    method: `GET`,
    params: {
      getAll: true,
    },
  },
  // Macrozones
  getMacrozones: {
    url: `/all-macrozones`,
    method: `GET`,
    params: {
      getAll: true,
    },
  },
  // Experiences
  validationAttempt: {
    url: `provider/experiences/request-validation`,
    method: `POST`,
  },
  requestValidation: {
    url: `provider/experiences/full`,
    method: `POST`,
  },
  updateValidation: {
    url: `provider/experiences/full`,
    method: `PUT`,
  },
  approveExperience: {
    url: `validator/experiences/pre-validate-experience`,
    method: `POST`,
  },
  approveExperienceNationalEvaluator: {
    url: `validator/experiences/validate-experience`,
    method: `POST`,
  },
  rejectExperience: {
    url: `validator/experiences/reject-experience`,
    method: `POST`,
  },
  getValidationForm: {
    url: `validator/experiences/get-validation-form`,
    method: `GET`,
  },
  getValidationFormNationalValidator: {
    url: `validator/experiences/get-validation-form-national`,
    method: `GET`,
  },
  getRejectReasons: {
    url: `/validator/reject-reasons`,
    method: `GET`,
  },
  getEditionExperienceForm: {
    url: `provider/experiences/get-edition-form`,
    method: `GET`,
  },
  getExperienceUpgradeForm: {
    url: `provider/experiences/get-upgrade-form`,
    method: `GET`,
  },
  getAllExperiences: {
    url: `experiences`,
    method: `GET`,
  },
  validatorGetUserExperiences: {
    url: `/validator/my-experiences`,
    method: `GET`,
  },
  providerGetUserExperiences: {
    url: `/provider/my-experiences`,
    method: `GET`,
  },
  adminGetUserExperiences: {
    url: `/admin/experiences`,
    method: `GET`,
  },
  validatornacionalGetUserExperiences: {
    url: `/validadornacional/experiences`,
    method: `GET`,
  },
  uploadImage: {
    url: `provider/image/new`,
    method: `POST`,
  },
  deleteImage: {
    method: `DELETE`,
    url: `provider/image`,
  },
  // User
  signIn: {
    url: `/user/signin`,
    method: `POST`,
  },
  signInProvider: {
    url: `/provider/signin`,
    method: `POST`,
  },
  getMe: {
    url: `/user/me`,
    method: `GET`,
  },
  getListUser: {
    url: `/admin/user/list`,
    method: `POST`,
  },
  getAllUsers: {
    url: `/admin/user/list-all`,
    method: `GET`,
  },
  postRecovery: {
    url: `/private/recovery`,
    method: `POST`,
  },
  postAddusuarios: {
    url: `/admin/user/create`,
    method: `POST`,
  },
  putusuarios: {
    url: `/admin/user`,
    method: `PUT`,
  },
  deleteUser: {
    method: `DELETE`,
  },
  // Roles,
  getListRoles: {
    url: `/admin/roles/list`,
    method: `POST`,
  },
  getItemsRoles: {
    url: `/admin/roles/items`,
    method: `GET`,
  },
  // Permisos
  getItemsPermisos: {
    url: `/admin/permisos/items`,
    method: `GET`,
  },
  // Rute Admin
  adminDesactivate: {
    url: `admin/experiences/desactivate`,
    method: `GET`,
  },
  // Rute Validator
  validatorDesactivate: {
    url: `validator/experiences/desactivate`,
    method: `GET`,
  },
  //macrozone
  getListMacrozone: {
    url: `/admin/macrozone/list`,
    method: `POST`,
  },
  getItemsMacrozone: {
    url: `/admin/macrozone/items`,
    method: `GET`,
  },
  //zone
  getZones: {
    url: `/provider/zones`,
    method: `POST`,
  },
  getListZone: {
    url: `/admin/zone/list`,
    method: `POST`,
  },
  getItemsZone: {
    url: `/admin/zone/items`,
    method: `GET`,
  },
  //destino
  getListDestino: {
    url: `/admin/destino/list`,
    method: `POST`,
  },
  //Regiones
  getListRegiones: {
    url: `/admin/regiones/list`,
    method: `POST`,
  },
  getItemsRegiones: {
    url: `/admin/regiones/items`,
    method: `GET`,
  },
  // Rute Provider
  providerPause: {
    url: `provider/experiences/pause`,
    method: `PUT`,
  },
  providerDelete: {
    method: `DELETE`,
    url: `provider/experiences`,
  },
  providerDeleteUpgrade: {
    method: `DELETE`,
    url: `provider/experiences/upgrade`,
  },
  //Categoria
  getListCategoria: {
    url: `/admin/categorias/list`,
    method: `POST`,
  },
  getItemsCategorias: {
    url: `/admin/categorias/items`,
    method: `GET`,
  },
  getListSubCategoria: {
    url: `/admin/subcategorias/list`,
    method: `POST`,
  },
  // Post generic
  post: {
    method: `POST`,
  },
  get: {
    method: `GET`,
  },
  validatorWatchExperience: {
    url: `validator/experiences/get-edition-form`,
    method: `GET`,
  },
  adminWatchExperience: {
    url: `admin/experiences/get-edition-form`,
    method: `GET`,
  },
  providerWatchExperience: {
    url: `provider/experiences/get-edition-form`,
    method: `GET`,
  },
  getmeLogout: {
    url: `/logout`,
    method: `GET`,
  },
  AutoSave: {
    url: `/provider/experiences/autosave`,
    method: `POST`,
  },
  FindAutoSave: {
    url: `/provider/experiences/autosave`,
    method: `GET`,
  },
  SavePropToEvent: {
    url: `/validator/experiences/update/prop`,
    method: `POST`,
  },
  RefreshToken: {
    url: `/admin/token/app/refresh`,
    method: `patch`,
  },
  getToken: {
    url: `/admin/token`,
    method: `get`,
  },
  loginExt: {
    url: `/auth/ext/login`,
    method: `post`,
  },
}
